import React, { PureComponent } from "react";
import queryString from "query-string";

import Table from "antd/lib/table";
import Popover from "antd/lib/popover";
import Button from "antd/lib/button";
import Select from "antd/lib/select";
import Popconfirm from "antd/lib/popconfirm";
import Drawer from "antd/lib/drawer";

import find from "lodash/find";
import findIndex from "lodash/findIndex";

import {
  readLevels,
  moveWordToLevel,
  updateLevel,
  getAllData
} from "helpers/api";

import ImageUpload from "components/ImageUpload";
import SearchDrawer from "./SearchDrawer";

import "./style.css";

const Option = Select.Option;

const newWordData = {};

const capitalize = ([first, ...rest], lowerRest = false) =>
  first.toLocaleUpperCase("TR") +
  (lowerRest ? rest.join("").toLowerCase() : rest.join(""));

class Words extends PureComponent {
  state = {
    data: {},
    uneditedData: {},
    isLoading: false,
    sortedInfo: {
      order: "ascend",
      columnKey: "id"
    },
    isEdited: false,
    isDrawerVisible: false
  };

  componentDidMount() {
    const { level } = this.getQueryValues();
    this.readData(level);
  }

  getQueryValues() {
    const { columns, level, move, replace } = queryString.parse(
      window.location.search
    );
    let currentColumns = ["id", "image", "de", "en", "tr", "de_plural"];
    let currentLevel = 1;
    let isMoveButtonVisible = false;
    let isReplaceVisible = false;
    if (columns) {
      currentColumns = columns.split(",");
    }
    if (level) {
      currentLevel = level;
    }
    if (move) {
      isMoveButtonVisible = move === "true";
    }
    if (replace) {
      isReplaceVisible = replace === "true";
    }
    return {
      columns: currentColumns,
      level: currentLevel,
      isMoveButtonVisible,
      isReplaceVisible
    };
  }

  componentDidUpdate() {
    const { uneditedData, data } = this.state;
    if (!uneditedData.words || !data.words) return;
    let isEdited = false;
    console.log("Changes:");
    uneditedData.words.forEach(uw => {
      const nw = find(data.words, { id: uw.id });
      [
        ...new Set([
          ...Object.keys(uw),
          "image",
          "de_plural",
          "example_en",
          "example_tr",
          "example_de",
          "type"
        ])
      ].forEach(key => {
        if (uw[key] !== nw[key]) {
          isEdited = true;
          if (key === "image") {
            console.log(`wordID: ${uw.id} ${key} changed`);
          } else {
            console.log(
              `wordID: ${uw.id} ${key} change: ${uw[key]} => ${nw[key]}`
            );
          }
        }
      });
    });
    !isEdited && console.log("no changes");
    console.log("====================");
    if (this.state.isEdited !== isEdited) {
      this.setState({ isEdited });
    }
  }

  handleConsoleLog = async () => {
    const allData = await getAllData();
    console.log(allData);
  };

  readData = async id => {
    this.setState({ isLoading: true, data: {} });
    const response = await readLevels(id);
    this.setState({
      data: response,
      isLoading: false,
      uneditedData: response,
      isEdited: false
    });
  };

  handleLevelChange = val => {
    const { columns } = this.getQueryValues();
    this.props.history.push(`/words?columns=${columns.join(",")}&level=${val}`);
    this.readData(val);
  };

  handleColumnChange = val => {
    const { data } = this.state;
    this.props.history.push(`/words?columns=${val.join(",")}&level=${data.id}`);
  };

  handleFieldEdit = (wordId, columnKey, newValue) => {
    this.setState(prevState => {
      return {
        data: {
          ...prevState.data,
          words: prevState.data.words.map((word, index) => {
            if (findIndex(prevState.data.words, { id: wordId }) === index) {
              return { ...word, [columnKey]: newValue };
            }
            return word;
          })
        }
      };
    });
  };

  handleWordReplace = wordId => {
    this.setState(prevState => {
      return {
        data: {
          ...prevState.data,
          words: prevState.data.words.map((word, index) => {
            if (findIndex(prevState.data.words, { id: wordId }) === index) {
              return { id: word.id, ...newWordData };
            }
            return word;
          })
        }
      };
    });
  };

  clearRow = wordId => {
    this.setState(prevState => {
      return {
        data: {
          ...prevState.data,
          words: prevState.data.words.map((word, index) => {
            if (findIndex(prevState.data.words, { id: wordId }) === index) {
              let newWord = { id: wordId };
              Object.keys(word)
                .filter(key => key !== "id")
                .forEach(key => {
                  newWord = { ...newWord, [key]: "" };
                });
              return newWord;
            }
            return word;
          })
        }
      };
    });
  };

  handleSave = async () => {
    const { data } = this.state;
    this.setState({ isLoading: true });
    await updateLevel(data.id, data.words);
    await this.readData(data.id);
  };

  drawerClose = () => {
    this.setState({ isDrawerVisible: false });
  };

  applyCorrections = () => {
    const correctionsAR = require("./ar");
    const correctionsES = require("./es");
    const correctionsIT = require("./it");
    const correctionsNL = require("./nl");
    const correctionsPL = require("./pl");
    const correctionsZH = require("./zh-CN");
    const correctionsRU = require("./ru");
    const correctionsRO = require("./ro");
    const correctionsFR = require("./fr");
    const frSpace = require("./fr_space");
    const correctionMap = [{ key: "fr", list: correctionsFR }];
    this.setState(prevState => {
      return {
        data: {
          ...prevState.data,
          words: prevState.data.words.map((word, index) => {
            let newWord = { ...word };
            correctionMap.forEach(item => {
              if (
                find(item.list, { id: word.id }) &&
                find(item.list, { id: word.id }).word
              ) {
                newWord[item.key] = find(item.list, { id: word.id }).word;
              }
            });
            // newWord.fr = newWord.fr.replace(/^la\s/i, "la ");
            // newWord.fr = newWord.fr.replace(/^le\s/i, "le ");
            // newWord.fr = newWord.fr.replace(/^les\s/i, "les ");
            // newWord.fr = newWord.fr.replace(/^l'/i, "l'");
            // newWord.fr = newWord.fr.replace(/^s'/i, "s'");
            // // if (!/\?$/i.test(newWord.fr)) {
            // if (newWord.type !== "noun") {
            //   newWord.fr = newWord.fr.toLowerCase();
            // }
            // Object.keys(newWord).forEach(key => {
            //   if (typeof newWord[key] === "string")
            //     newWord[key] = newWord[key].trim();
            // });
            return newWord;
          })
        }
      };
    });
  };

  render() {
    const {
      data,
      isLoading,
      sortedInfo,
      isEdited,
      isDrawerVisible
    } = this.state;
    if (!data) return null;
    const {
      columns: visibleColumns,
      level,
      isMoveButtonVisible,
      isReplaceVisible
    } = this.getQueryValues();

    const { id, words } = data;

    let columns = [];
    let dataSource = [];

    if (words) {
      columns = [
        ...new Set([
          ...Object.keys(words[0]),
          "image",
          "de_plural",
          "example_en",
          "example_tr",
          "example_de",
          "type"
        ])
      ]
        .sort((a, b) => {
          if (a === "id" || a === "image") {
            return -1;
          } else if (b === "id" || b === "image") {
            return 1;
          }
          return 0;
        })
        .map(key => {
          if (key === "image") {
            return {
              title: key,
              render: record => {
                return (
                  <ImageUpload
                    image={record.image}
                    onChange={imageURL => {
                      this.handleFieldEdit(record.id, "image", imageURL);
                    }}
                  />
                );
              },
              key: key
            };
          } else if (key === "id") {
            return {
              title: key,
              dataIndex: key,
              key: key,
              sorter: (a, b) => a.id - b.id,
              sortOrder: sortedInfo.columnKey === "id" && sortedInfo.order
            };
          }
          return {
            title: key,
            key: key,
            render: record => (
              <input
                value={record[key]}
                onChange={e =>
                  this.handleFieldEdit(record.id, key, e.target.value)
                }
              />
            )
          };
        });

      dataSource = words.map(word => ({
        key: word.id,
        ...word
      }));
    }

    const actions = {
      title: "Actions",
      key: "actions",
      render: record => (
        <div>
          {isMoveButtonVisible && (
            <Popover
              content={
                <Select
                  defaultValue={level}
                  style={{ width: 120 }}
                  onChange={async nextLevelID => {
                    this.setState({ isLoading: true, data: {} });
                    const word = find(words, { id: record.id });
                    await moveWordToLevel(id, nextLevelID, word);
                    this.readData(id);
                  }}
                >
                  {new Array(70).fill(0).map((_, index) => (
                    <Option key={index} value={index + 1}>
                      {index + 1}
                    </Option>
                  ))}
                </Select>
              }
              title="Select level to move"
              trigger="hover"
            >
              <Button style={{ marginRight: 10 }}>Move Word</Button>
            </Popover>
          )}
          {isReplaceVisible && (
            <a onClick={() => this.handleWordReplace(record.id)}>
              Replace WOrd
            </a>
          )}
          <Popconfirm
            title="Are you sure？"
            okText="Yes"
            cancelText="No"
            onConfirm={() => this.clearRow(record.id)}
          >
            <Button type="danger">Clear</Button>
          </Popconfirm>
        </div>
      )
    };

    const columnKeys = columns.map(column => (
      <Option id={column.key} key={column.key}>
        {column.key}
      </Option>
    ));

    const filteredColumns = columns.filter(
      column => visibleColumns.indexOf(column.key) !== -1
    );

    return (
      <div className="Words">
        <div>
          <span>Select Level: </span>
          <Select
            value={id}
            style={{ width: 120 }}
            onChange={this.handleLevelChange}
          >
            {new Array(70).fill(0).map((_, index) => (
              <Option key={index} value={index + 1}>
                {index + 1}
              </Option>
            ))}
          </Select>
        </div>
        <div style={{ margin: "10px 0" }}>
          <span>Visible Columns: </span>
          <a
            onClick={() =>
              this.handleColumnChange(columns.map(item => item.key))
            }
          >
            Select All
          </a>
          <a onClick={() => this.handleColumnChange([])}>Clear All</a>
          <Select
            mode="multiple"
            style={{ width: "calc(100vw - 140px)" }}
            placeholder="Please select"
            value={visibleColumns}
            onChange={this.handleColumnChange}
          >
            {columnKeys}
          </Select>
        </div>
        <div>
          <Button onClick={() => this.setState({ isDrawerVisible: true })}>
            OPEN SEARCH
          </Button>
        </div>
        <h1 className="Words__title">
          WORDS {id} (COUNT: {words ? words.length : "-"})
        </h1>
        <Button onClick={this.applyCorrections} style={{ margin: 20 }}>
          Apply Corrections
        </Button>
        <Table
          dataSource={dataSource}
          columns={[...filteredColumns, actions]}
          pagination={false}
          scroll={{ x: 900 }}
          loading={isLoading}
        />
        {isEdited && (
          <div className="Words__button-save">
            <Button type="danger" onClick={this.handleSave} size="large">
              SAVE CHANGES
            </Button>
          </div>
        )}
        <div className="Words__download">
          <Popconfirm
            title="Are you sure？"
            okText="Yes"
            cancelText="No"
            onConfirm={this.handleConsoleLog}
          >
            <Button>CONSOLE LOG WORDS_ORIGINAL</Button>
          </Popconfirm>
        </div>
        <Drawer
          title="Search"
          placement="right"
          width={900}
          closable
          onClose={this.drawerClose}
          visible={isDrawerVisible}
          destroyOnClose
        >
          <SearchDrawer
            columns={filteredColumns}
            handleLevelChange={this.handleLevelChange}
          />
        </Drawer>
      </div>
    );
  }
}

export default Words;



// WEBPACK FOOTER //
// ./src/containers/Words/index.jsx